import {make} from "vuex-pathify";
import AuthService from "../../services/auth.service";
import $http from "../../plugins/axios";
import router from "../../router";
import $const from "../../utils/const"
import {session, storage} from "../../utils/map";
import store from "../../store/store";
import ActionTypes from "../ActionTypes";

const state = {
    token: localStorage.getItem($const.LOCAL_STORAGE_KEY.FPTAI_MESSENGER_USER_JWT) || null
}
const mutations = make.mutations(state)

const actions = {
    ...make.actions(state),
    signIn() {
        const provider = storage.getItem($const.LOCAL_STORAGE_KEY.PROVIDER)
        AuthService.signIn(JSON.parse(provider))
    },
    async signOut() {
        await AuthService.revokeToken()
        const provider = storage.getItem($const.LOCAL_STORAGE_KEY.PROVIDER)
        localStorage.removeItem($const.LOCAL_STORAGE_KEY.FPTAI_MESSENGER_USER_JWT)
        storage.clear()
        AuthService.signOut(JSON.parse(provider))
    },
    getToken({dispatch}) {
        const provider = storage.getItem($const.LOCAL_STORAGE_KEY.PROVIDER)
        AuthService.getToken(JSON.parse(provider), router.currentRoute.query)
            .then(res => {
                const userJwt = res.data;
                localStorage.setItem($const.LOCAL_STORAGE_KEY.FPTAI_MESSENGER_USER_JWT, JSON.stringify(userJwt));
                dispatch('setToken', userJwt)
                store.commit(ActionTypes.USER, userJwt.user)
                store.commit(ActionTypes.TOKEN, userJwt.user_token)
                $http.defaults.headers.common['Authorization'] = `Bearer ${userJwt.user_token}`
                const pathCache = storage.getItem($const.LOCAL_STORAGE_KEY.PATH_CACHE)
                router.replace(pathCache ? pathCache : '/')
            })
    }
}
const getters = {
    isLoggedIn: state => !!state.token,
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
